module.exports = __webpack_public_path__ + "img/tj.2e894c81.jpg";